import { users } from "@api/courses/reviewStats/users/api";

export const reviewStats = {
  users,
};
